// extracted by mini-css-extract-plugin
export default {"badge":"r_QxHy"};